export default __webpack_public_path__ + "static/1-2e4727d641ac4ebaadb3a16c52e8467d.png";